// initialed state

export const initialState = () => ({
	editorAccordionMenuItems: [],
	isAccordionMenuOpen: false,
	isChangingAction: false,
});

const state = initialState();

export default state;
